import React from 'react';
import ReactDOM from 'react-dom/client';
import Main from './main';
import './main.css';
import { createBrowserRouter, RouterProvider } from 'react-router-dom';
import Homepage from './pages/homepage';
import Collection from './pages/collection';
import Shop from './pages/shop';
import Account from './pages/account';
import About from './pages/about';

import reportWebVitals from './reportWebVitals';
type route = {
  path:string,
  name:string,
  element: React.ReactNode
}
const routes: Array<route> = [
  { path: '/', name: 'Home', element: <Homepage />},
  { path: '/about', name: 'About', element: <About />},
  { path: '/collection', name: 'Collection', element: <Collection />},
  { path: '/shop', name: 'Shop', element: <Shop />},
  { path: '/account', name: 'Account', element: <Account />},
]
const router = createBrowserRouter([
  {
    path: '/',
    element: <Main />,
    children: routes.map((route) => ({
      index: route.path === '/',
      path: route.path === '/' ? undefined : route.path,
      element: route.element,
    })),
  },
])

const root = ReactDOM.createRoot(document.getElementById('root')!);
root.render(
  <RouterProvider router={router}/>
);


// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
